import Header from "../components/Header";
import MenuMobileHorizontal from "../components/MenuMobileHorizontal";
import { useRecoilState } from "recoil";
import { barreDefilement } from "../services/atom.js";
import { useLocation } from "react-router-dom";
import HeaderScroll from "../components/HeaderScroll";

const Layout = ({ children }) => {
  const [hauteurScroll, setHauteurBarre] = useRecoilState(barreDefilement);
  const location = useLocation();

  // la fonction pour voir la valeur du scroll
  const handleScroll = (e) => {
    let p = e.currentTarget.scrollTop;
    setHauteurBarre((t) => (t = p));
  };

  return (
    <div
      onScroll={handleScroll}
      className="flex flex-col w-full h-screen overflow-scroll overflow-x-hidden lg:flex-row lg:relative"
    >
      <div
        className={`transition-all z-50 flex fixed lg:hidden top-0 left-0 px-4 py-2 w-full h-20 bg-[#2b3e45] items-center space-x-2 lg:space-x-0 ${
          hauteurScroll >= 500 ? "translate-y-0" : "-translate-y-24"
        }`}
      >
        <HeaderScroll />
      </div>

      <div
        className={`transition-all z-50 flex fixed lg:hidden top-0 left-0 px-4 py-2 w-full h-20 bg-[#2b3e45] items-center space-x-2 lg:space-x-0 ${
          location.pathname === "/projets" ||
          location.pathname === "/blog" ||
          location.pathname === "/contact" ||
          location.pathname === "/livre-dor"
            ? "translate-y-0"
            : "-translate-y-24"
        }`}
      >
        <HeaderScroll />
      </div>

      <div
        className={`lg:relative lg:max-w-[512px] ${
          location.pathname === "/projets" ||
          location.pathname === "/blog" ||
          location.pathname === "/contact" ||
          location.pathname === "/livre-dor"
            ? "hidden lg:flex"
            : "flex"
        }`}
      >
        <Header />
      </div>
      <div className="bg-[#233238] lg:flex lg:justify-center w-full lg:relative">
        {children}
      </div>
      <MenuMobileHorizontal />
    </div>
  );
};

export default Layout;
